export const iconFontAwesomeMedicalHealthIdCardClip = (
	<i className="fa-solid fa-id-card-clip"></i>
);
